import CompanyMapper from "./company-mapper";
import { homeDefaults } from "./defaults";
import { HomeModel } from "./types";
import { CompanyDocument } from "../../api/commercial/generated-types";

const mapDocumentToPageModel = (
  document: CompanyDocument,
  basicAccountApplicationRef?: string,
): HomeModel => {
  const isCompanyManuallyEntered = document.isCompanyManuallyEntered;

  return {
    basicAccountApplicationRef,
    isCompanyManuallyEntered,
    manuallyEnteredCompany: isCompanyManuallyEntered
      ? CompanyMapper.mapDocumentToPageModel(document)
      : homeDefaults.manuallyEnteredCompany,
    selectedCompany: isCompanyManuallyEntered
      ? homeDefaults.selectedCompany
      : CompanyMapper.mapDocumentToPageModel(document),
  };
};

const HomeMapper = {
  mapDocumentToPageModel,
};

export default HomeMapper;
